<template>
  <div :class="`inviteCard  ${isNight ? 'inviteCard_dark' : ''}`">
    <div class="invHeader">
      <div :class="`invCodeTip  ${isNight ? 'invCodeTip_dark' : ''}`">{{ $t("inviteDetail.invitationCode") }}</div>
      <img :src="ruleUrl" class="ruleIcon" @click="rule" />
    </div>
    <div :class="`invCode  ${isNight ? 'invCode_dark' : ''}`">{{inviteCode}}</div>
    <div class="inviteBtn">
      <div class="textWrap" @click="invite">
        <div class="btnContent" key="signUp">
          {{ $t("inviteDetail.toInvite") }}
        </div>
      </div>
    </div>
    <div class="inviteImage">
      <img :src="rulePic" class="rulePic"/>
    </div>
  </div>
</template>

<script>
import rulePng from "../images/rule.webp"
import rule_darkPng from "../images/rule_dark.webp"

export default {
  props: ["isNight","backgroundStyle","rulePic","fontStyle","inviteCode"],
  data() {
    return {
      rulePng,
      inviteIcon:'',
      rule_darkPng,
      event:"",
      style:{},
    };
  },
  mounted() {
  },
  beforeUpdate() {},
  computed: {
    ruleUrl() {
      if (this.isNight) {
        return rule_darkPng
      } else {
        return rulePng
      }
    },
  },
  methods: {
    rule() {
      this.$emit("ruleEvent");
    },
    invite() {
      this.$emit("toInvite");
    },
  },
};
</script>

<style scoped lang="stylus">
.inviteCard {
  margin: 0rem 0.48rem 0rem 0.48rem;
  // justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #ffffff;
  border-radius: 0.48rem;
  width: 9.8409rem;
  font-family: 'OPPOSans 2.14 NoVF';
  font-weight: 500;
  // height:10.441rem;
  .invHeader {
    display: flex;
    align-items: center;
    height:1.08rem;
  }
  .invCodeTip {
    height: 0.6rem;
    width: 6.81rem;
    font-size: 0.42rem;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0.6rem;
    color: rgba(0, 0, 0, 0.55);
    margin: 0 0.39rem 0 1.53rem;
    padding-top: 0.48rem;
  }
  .invCodeTip_dark {
    color: rgba(255, 255 255, 0.55);
  }
  .ruleIcon {
    width: 0.72rem;
    height: 0.72rem;
    margin: 0.39rem 0.39rem 0 0;
  }
  .invCode {
    height: 1.02rem;
    font-size: 0.72rem;
    line-height: 1.02rem;
    color: rgba(0, 0, 0, 0.85);
    margin: 0.48rem 1.53rem 0 1.53rem;
  }
  .invCode_dark {
    color: rgba(255, 255, 255, 0.85);
  }
  .inviteImage{
    margin: 0 0.48rem 0.6rem;
    height: 5.04rem;
  }
  .rulePic{
    width:8.88rem;
    height:5.04rem;
  }
  .inviteBtn {
    display: flex;
    font-size: 0.42rem;
    margin-top: 0.24rem;
    margin-bottom: 0.72rem;
    width: 6.6rem;
    height: 1.32rem;
    background: #fd8326;
    border-radius: 0.66rem;
    border: none;
    .textWrap {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'OPPOSans 2.14 NoVF';
      font-weight: 500;
      color: #ffffff;
    }
  }
  .line {
    height: 0.01rem;
    background-color: rgba(0, 0, 0, 0.12);
    width: 296px;
    margin: 0.6rem 0.48rem 0.6rem 0.48rem;
  }
  .inviteStepWarp {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.48rem;
    flex-direction: column;
    position:relative;
  }
  .firstInviteStep {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 8.88rem;
    margin-bottom :0.87rem;
  }
  .firstInviteStep:last-child{
    margin-bottom: 0.6rem;
  }
  .verticalLine {
    border-left 0.5px dashed rgba(0, 0, 0, 0.3); 
    // height:2.82rem; 
    position:absolute;
    top:1.08rem;
    left:1.08rem;
  }
  .verticalLine_dark {
    border-left 0.5px dashed rgba(255, 255, 255, 0.3); 
  }
  .stepIconWrap{
    position :relative;
    margin-right: 0.3rem;
    z-index :2
  }
  .stepIcon {
    width: 0.72rem;
    height: 0.72rem;
    position :absolute
    top:0.18rem;
    left:0.18rem
  }
  .stepText {
    width: 6.96rem;
    font-size: 0.36rem;
    color: rgba(0, 0, 0, 0.55);
  }
  .stepText_dark {
    color: rgba(255, 255, 255, 0.55);
  }
  .stepNum {
    width: 0.3rem;
    // color: #58BA81;
    font-size: 0.48rem;
    margin-right: 0.24rem;
  }
  .stepCircle {
    width: 1.08rem;
    height: 1.08rem;
    border-radius :50%
  }
}
.inviteCard_dark {
    background: #404040;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/inviteCard.vue